"use strict";

exports.__esModule = true;
exports.default = void 0;

var _PrimusPersonData = _interopRequireDefault(require("./PrimusPerson.data.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const PrimusPersonSchema = (_ref) => {
  let schema = _ref.schema,
      props = _objectWithoutPropertiesLoose(_ref, ["schema"]);

  const enumKeys = Object.keys(_PrimusPersonData.default).map((key, index) => {
    return key * 1;
  });
  const enumNames = Object.values(_PrimusPersonData.default).map((name, index) => {
    return name;
  });
  return _extends({}, props, {
    schema: _extends({}, schema, {
      type: "number",
      enum: enumKeys,
      enumNames: enumNames
    })
  });
};

var _default = PrimusPersonSchema;
exports.default = _default;
module.exports = exports.default;